import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import {
  shipperNameSelector,
  isArchivedSelector,
  tokenExpirationSelector,
} from '../../../data/shippers.js'
import {showArchiveShipperModal} from './ArchiveShipperModal.js'
import Forms from './Forms/index.js'
import {useSelector} from '../../../store.js'
import {settingsShippersShipperIDSelector} from './ShippersFunctions.js'
import className from '../../../common/className.js'
import {ERROR_TYPE__FINISH_SETUP} from '../../../common/constants/index.js'
import Icon from '../../../common/icons/Icon.js'

export default function EditForm({shipper}) {
  const shipperName = useSelector((state) =>
    shipperNameSelector(state, {shipperID: shipper.id}),
  )
  const isArchived = useSelector((state) =>
    isArchivedSelector(state, {shipperID: shipper.id}),
  )
  const tokenExpiration = useSelector((state) =>
    tokenExpirationSelector(state, {shipperID: shipper.id}),
  )
  const editID = useSelector(settingsShippersShipperIDSelector)

  const Form = Forms[shipper.vendor]
  const formName = `settings__shippers__${shipper.id}`
  const href = `#/settings/shipper/${shipper.id}`
  const isExpanded = editID === shipper.id
  const needsReauth = !isArchived && tokenExpiration.isExpired
  const needsSetup =
    !isArchived &&
    tokenExpiration.integrationIssue?.errorType === ERROR_TYPE__FINISH_SETUP

  return (
    <li
      className={className`settings-list-item clearfix ${{
        expanded: isExpanded,
        'archived wrap--reveal': isArchived,
        warning: needsReauth,
      }}`}
    >
      <div className="wrap--row ">
        <div className="medium-4 columns list__title-logo">
          <div className={className`wrap--logo ${shipper.vendor}`} />
        </div>
        <div className="make-medium-grey medium-5 columns wrap--reauth-notice">
          <strong className="fs-01 margin-right-5 v-align-middle">
            {shipperName}
          </strong>
          {needsReauth && (
            <div>
              <strong className="label__callout label__callout--yellow v-align-middle">
                Reauthorize
              </strong>
            </div>
          )}
          {needsSetup && (
            <div>
              <strong className="label__callout label__callout--yellow v-align-middle">
                Finish Setup
              </strong>
            </div>
          )}
        </div>
        <div className="medium-2 columns align-right">
          {isArchived ? (
            <>
              <div>
                <em className="fs-01 v-align-middle text--lt-grey">Archived</em>
              </div>
              <ButtonPrimary
                isOutlined
                size="xx-sm"
                className="margin-top-5 btn--reveal"
                onClick={() => showArchiveShipperModal(shipper.id)}
              >
                Unarchive
              </ButtonPrimary>
            </>
          ) : (
            <span className="fs-01 v-align-middle">
              <a
                className="inline-text-button settings-list-item-button edit-url"
                href={href}
              >
                <Icon name="sym-edit" className="fs-01 margin-right-2" />
                <span className="button-text">Edit</span>
              </a>
            </span>
          )}
        </div>
      </div>
      {isExpanded && <Form shipper={shipper} formName={formName} />}
    </li>
  )
}
